import axios from 'axios';
import Vue from 'vue';
import ApiError from './Errors/ApiError';
import i18n from './i18n';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.NODE_ENV === 'development' ? 120000 : 120000,
});

httpClient.defaults.headers.common['Accept-Language'] = i18n.locale;
httpClient.defaults.withCredentials = true;

httpClient.interceptors.request.use(
  config => config,
  error => Promise.reject(new ApiError(error.message, {}, 0)),
);

httpClient.interceptors.response.use(
  response => response,
  (error) => {
    let { message } = error;
    const data = {};

    if (error.code === 'ECONNABORTED') {
      return Promise.reject(new ApiError(i18n.t('common.timeoutError')));
    }

    if (!error.response) {
      return Promise.reject(new ApiError(i18n.t('common.networkError'), data, null));
    }

    if (error.response.status !== 422) {
      Vue.prototype.$toast.error(error.response.data.message);
    }

    if (!error.response.data) {
      return Promise.reject(new ApiError(message, data, error.response.status));
    }

    if (error.response.data.message) {
      // eslint-disable-next-line prefer-destructuring
      message = error.response.data.message;
    }

    return Promise.reject(new ApiError(
      message,
      error.response.data.errors ?? error.response.data.data ?? {},
      error.response.status,
    ));
  },
);

export default httpClient;
